<template>
  <MainWrapper>
    <div class="single-master-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h3 class="mb-30">Компании</h3>
                    <div class="gray-line mb-15"></div>
                    <div class="filters mb-15">
                        <router-link :to="'/user/companies/create'" class="single-filter pointer mr-30">
                            <div class="filter-icon mr-10">
                                <font-awesome-icon class="icon" :icon="['fal', 'building']" />
                            </div>
                            <span>
                                Создать учреждение
                            </span>
                        </router-link>
                    </div>
                    <div class="gray-line mb-20"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12" v-if="!noCompanies">
                    <div class="white-panel pt-20 pb-20 pr-20 pl-20">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="tabs mb-30">
                                    <h4 class="mb-20">Мои компании</h4>
                                    <div class="light-gray-line"></div>
                                </div>
                            </div>
                            <div class="row minus-margin">
                                <div class="col-lg-2" v-for="(i, k) in myCompanies" :key="k">
                                    <router-link :to="`/companies/${i.slug}/admin`">
                                        <div :style="{ background: i.photo ? i.photo : '#ccc' }" class="mb-10 company-photo">
                                            <img style="width:100%" :src="i.photo" />
                                        </div>
                                        <span class="block mb-20">{{ i.name }}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="col-lg-12" v-if="noCompanies">
                    <holder title="У вас ещё нет компаний!" icon="folder-open" desc="Для того чтобы добавить компанию, вам необходимо нажать на кнопку 'Создать учреждение'" />
                </div>
            </div>
        </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
    @import '../../styles/main.core.vars.styl';

    .icon
        font-size: 18px

    .minus-margin
        margin-left: -30px
        margin-right: -30px 

    .company-photo
        /* height: 103px; */
        border-radius: 4px;
        box-shadow: $box_shadow

    .single-filter
        display: inline-flex
        align-items: center
        .filter-icon
            width: 38px
            height: 38px
            display: inline-flex
            align-items: center
            justify-content: center
            border-radius: 100%
            border: 1px solid cyan_dark_color
            color: cyan_dark_color
    
    .spec-photo
        width: 70px
        height: 70px
        background: #ccc
        border-radius: 100%

    textarea
        border-radius: 8px
        border: 1px solid $light_gray
        padding: 10px 15px
        width: 500px
        max-width: 100%
        min-height: 150px

    .services-list
        width: 500px
        max-width: 100%

    .map-wrapper
        overflow: hidden
        border-radius: 4px
        width: 820px
        max-width: 100%
</style>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import MainWrapper from '@/wrappers/MainWrapper.vue';
    import Button from '@/components/Button.vue';
    import Holder from '@/components/Holder.vue';

    import http from '@/methods/http.ts';

    @Component({
        components: {
            MainWrapper,
            Button,
            Holder
        }
    })
    export default class MyCompanies extends Vue {
        tab = 3;

        noCompanies = false;

        myCompanies = [];

        created() {
            this.getMyCompanies();
        }

        getMyCompanies() {
            http('my_companies', 'get', this.$store.state.token, {})
                .then(r => {
                    this.myCompanies = r.data;
                    if (!r.data.length) {
                        this.noCompanies = true;
                    }
                });
        }
    }
</script>